import { render } from "./error_400.vue?vue&type=template&id=1c7f271b"
import script from "./error_400.vue?vue&type=script&lang=js"
export * from "./error_400.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__